export default __webpack_public_path__ + "static/media/about-us.6435c0a2.png";